import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getResetPassApi } from "../../Service/Api/LoginResetPassApi"
import { getErrors, getResetPassMessageSuccess } from "../Reducer/LoginResetPassReducer"

// Watchers
function* resetPasswordSaga() {
	yield takeEvery("reset_password/getResetPassMessage", getResetPass)
}

// Sagas
function* getResetPass(action) {
	// console.log(action.payload, "saga payload")

	try {
		const data = yield call(getResetPassApi, action.payload)
		console.log(action.payload, "resend saga response")

		if (data.request.status == 200) {
			yield put(getResetPassMessageSuccess(data))
		} else {
			yield put(getErrors(data.response.data))
			console.log(data.response.data, 'error from saga')
		}
	} catch (error) {
		console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(resetPasswordSaga)])
}
